import React, { useEffect, useState } from 'react';
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Tabs, Tab } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
import Froala from './froala';
import './projectprogress.css';
// Require Font Awesome.
import 'font-awesome/css/font-awesome.css';
import { Link } from 'react-router-dom';
// import { height } from 'dom-helpers';


const ProjectProgress = (props) => {
  console.log('Project Progress');
  const [permissions, SetPermission] = useState({});
  const prms = props.match.params;
  const [pro, setPro] = useState({title: '', description: '', template: '', bgcolor: '', fgcolor: '', project: '', about_school: '', ela_connection: '', math_connection: '', sse: '', engandtech: ''});
  const [roles, setRoles] = useState([]);
  const [members, setMembers] = useState([]);


  useEffect(()=>{(async()=>{
    try {
      console.log("perms",prms);
      axios.post(`${BASE_URL}/group/getProjectPerms.php`,{groupid:prms.id}).then(async(res)=>{
        let res3 = await axios.post(`${BASE_URL}/group/getproject.php`, {proid: prms.proid , groupid:prms.id});
        axios.post(`${BASE_URL}/group/getdetails.php`, {gid: prms.id}).then((res2)=>{
          SetPermission(res.data.data.perms);
          setMembers(res2.data.data.members);
          setRoles(res3.data.data.roles);
          setPro(res3.data.data.project);
        });
      });
      
    }catch(e) {
      Swal.fire('Error while getting members', '', 'error');
    }
  })()}, [])




  const sectionContent = (html) => {
    return (
      <div dangerouslySetInnerHTML={{__html:html}}>

      </div>
    )
  }
  // Tabs and its content
  const ControlledTabs = ()=> {
    const [key, setKey] = useState('intro');

    return (
      <Tabs 
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3 m-auto text-center fs-6 justify-content-center align-items-center fw-bold gap-4"
      >
        <Tab eventKey="intro" title="Intro">
          {/* <Sonnet /> */}
          <div className="pt-5">
            <h1 className="text-left fw-bold ps-4">
              {pro.title}
            </h1>
            <h5 className="text-left fw-bold ps-4">
              Description:-
            </h5>
            {sectionContent(pro.description)}
            <div className="row">
              {members.map((member, key)=>{
                return (
                    <div key={key} className='col-6 text-left'>
                      <h4 className='ps-3'>{member.fullname}</h4>
                      <label htmlFor='body' className="fs-5 ps-3 mt-3 fw-bolder text-primary">ROLE</label>
                      
                      {(permissions.write_intro == 1) ? <React.Fragment><Froala {...member} type={'group'} idx = {`role${+key}`} proId={prms.proid} data={roles[key]?.role} section={'role'} gId={prms.id}/> </React.Fragment> : sectionContent(roles[key]?.role)}
                    </div>
                )
              })}
            </div>
          </div>
        </Tab>
        {/*  <Tab eventKey="project" title="Project">
          <div className='text-left ps-5 mt-5'>
            <h4 className='fw-bold'>This part should cover those keypoints:</h4>
            <ul className='ps-5 list-group list-group-horizontal'>
              <li className='list-group-item fw-bold'>Introduction</li>
              <li className='list-group-item fw-bold'>Materials</li>
              <li className='list-group-item fw-bold'>Procedure</li>
              <li className='list-group-item fw-bold'>Scientific Principle</li>
            </ul>
          </div>
          <div className="text-center p-5">
              {(permissions.write_project == 1) ? <React.Fragment> <Froala {...permissions} type={'group'} idx={`project${+key}`} gId={prms.id} proId={prms.proid} data={pro.project} section={'project'} /></React.Fragment> : sectionContent(pro.project)}
          </div>
        </Tab> */}
        <Tab eventKey="about" title="About School">
          <div className="text-center p-5">
              {(permissions.write_aschool == 1) ? <React.Fragment>  <Froala {...permissions} type={'group'} idx={`about_school${+key}`} gId={prms.id} proId={prms.proid} data={pro.about_school}  section={'about_school'}/></React.Fragment> : sectionContent(pro.about_school)}
          </div>
        </Tab>
        <Tab eventKey="ela" title="ELA Connection">
          <div className="text-center p-5">
            {(permissions.write_ela == 1) ? <React.Fragment>  <Froala {...permissions} type={'group'} idx={`ela_connection${+key}`} gId={prms.id} proId={prms.proid} data={pro.ela_connection}  section={'ela_connection'}/> </React.Fragment>: sectionContent(pro.ela_connection)}
          </div>
        </Tab>
        <Tab eventKey="math" title="Math Connection">
          <div className="text-center p-5">
            {(permissions.write_math == 1) ? <React.Fragment>  <Froala {...permissions} type={'group'} idx={`math_connection${+key}`} gId={prms.id} proId={prms.proid} data={pro.math_connection}   section={'math_connection'}/></React.Fragment> : sectionContent(pro.math_connection)}
          </div>
        </Tab>
        {/* <Tab eventKey="sse" title="S.S.E">
          <div className="text-center p-5">
            {(permissions.write_sse == 1) ? <React.Fragment> <Froala {...permissions} type={'group'} idx={`sse${+key}`} gId={prms.id} proId={prms.proid} data={pro.sse}  section={'sse'}/></React.Fragment> : sectionContent(pro.sse)}
          </div>
        </Tab> */}
        <Tab eventKey="eat" title="Engineering &amp; Technologies">
          <div className="text-center p-5">
            {(permissions.write_eandt == 1) ? <React.Fragment>  <Froala {...permissions} type={'group'} idx={`engandtech${+key}`} gId={prms.id} proId={prms.proid} data={pro.engandtech}  section={'engandtech'}/> </React.Fragment>: sectionContent(pro.engandtech)}
          </div>
        </Tab>
      </Tabs>
    )
  };
  if(pro.title === '' || roles === [] || permissions ==={}){
    return <div></div>
  }else
  return (
    <>
    
      <PanelHeader size="sm" />
      <div className='w-100 bg-dark' style={{ zIndex: 2, height: '60px',marginTop:"-30px",paddingTop:"1px"}}>
        <Link style={{ display: 'block', width: '100px'}} to={`/groups/${prms.id}`} className='btn btn-primary fs-5 p-2 fw-bolder ms-3'><i className="fas fa-arrow-left fa-lg"></i></Link>
      </div>
      <div style={{position: 'absolute'}} className="text-center w-100 mx-auto mt-5 content">
          <ControlledTabs />    
      </div>
    </>
  );
};

export default ProjectProgress;